import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=af7d191a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=af7d191a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7d191a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af7d191a')) {
      api.createRecord('af7d191a', component.options)
    } else {
      api.reload('af7d191a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=af7d191a&scoped=true&", function () {
      api.rerender('af7d191a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/comp/SearchFilterTokens.vue"
export default component.exports